import { faXmark, faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { useLocation } from 'react-router-dom';
import menuItems from '../../assets/data/menu';
import LinkedInLink from '../LinkedInLink';
import style from './Menu.module.css';
import MenuItemMobile from './MenuItemMobile';

function MobileMenu() {
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <nav role="navigation" className="d-block d-lg-none">
      <div id={style.menuToggle}>
        <div
          data-testid="openMenu"
          className={style.menuAction}
          onClick={() => setShowMenu(!showMenu)}
        >
          <FontAwesomeIcon
            data-testid="toggleMenuIcon"
            icon={showMenu ? faXmark : faBars}
          />
        </div>

        {showMenu && (
          <ul
            id={style.menu}
            className={cx('list-unstyled', { [style.open]: showMenu })}
            onClick={() => setShowMenu(false)}
          >
            {menuItems.map((item) => (
              <li key={item.path}>
                <MenuItemMobile
                  icon={item.icon}
                  name={item.longName}
                  isCurrent={location.pathname === item.path}
                  url={item.path}
                />
              </li>
            ))}

            <li>
              <LinkedInLink>
                <FormattedMessage id="menu.linkedin" tagName="span" />
              </LinkedInLink>
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
}

export default MobileMenu;
